"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var WickedApiClient_1 = require("../api/WickedApiClient");
var FetchDataComponent = /** @class */ (function () {
    function FetchDataComponent(http, baseUrl) {
        var _this = this;
        var client = new WickedApiClient_1.SampleDataClient(http, baseUrl);
        client.weatherForecasts().subscribe(function (result) {
            _this.forecasts = result;
        }, function (error) { return console.error(error); });
    }
    return FetchDataComponent;
}());
exports.FetchDataComponent = FetchDataComponent;
